import { createContext } from 'react';
// import Plausible from 'plausible-tracker';

import { TrackingEvent } from './Tracking.events';
import Matomo from '@canvasflow/analytics/src/tracker/tracker';

export const LOCATION_CHANNEL_KEY = 'location';

export const TrackingContext = createContext<ContextProps>({
	gtag: null,
	gtm: null,
	metaPixel: null,
	tiktokPixel: null,
	locationChannel: new BroadcastChannel(LOCATION_CHANNEL_KEY),
	matomo: null,
	sendEvent: () => {},
});

interface ContextProps {
	location?: Location;
	locationChannel: BroadcastChannel;
	sendEvent: (event: TrackingEvent) => void;
	gtag?: any;
	gtm?: any;
	plausible?: any;
	tiktokPixel?: any;
	metaPixel?: any;
	matomo?: Matomo | null;
}
